import { getLanguage } from '../helpers/url';
import { obxEndpoint, shortname } from './consts';
function V3Factory(baseEndpoint = null, distributor = null, brandingStyle = distributor) {
    distributor = distributor || shortname;
    baseEndpoint = baseEndpoint || obxEndpoint;
    const serviceEndpoint = `${baseEndpoint}/Services`;
    const pageEndpoint = `${baseEndpoint}/Pages`;
    const endpoints = {
        search: `${serviceEndpoint}/EntityService.jsws/Search`,
        injection: `${serviceEndpoint}/Injection.aspx`,
        searchPage: `${pageEndpoint}/Search.aspx`,
        getBooking: `${serviceEndpoint}/BookingService.jsws/GetBookingQuote`,
    };
    const setDistributor = (_distributor) => {
        if (_distributor)
            distributor = _distributor;
    };
    const setBrandingStyle = (_brandingStyle) => {
        if (_brandingStyle)
            brandingStyle = _brandingStyle;
    };
    let extraExls = [];
    const setExtraExlData = (_exls = []) => {
        extraExls = _exls;
    };
    const postJsonData = async function (url, request, queryString = '') {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(request),
        }).catch((error) => {
            console.error('Error:', error);
        });
        return await response.json();
    };
    const search = async function (request, shortname = distributor) {
        request.ShortName = shortname;
        return await postJsonData(endpoints.search, { request: request });
    };
    const getBooking = async function (request, shortname = distributor) {
        request.Shortname = shortname;
        return await postJsonData(endpoints.getBooking, { request: request });
    };
    const redirectToCABS = function (favourites = [], _distributor = '', _brandingStyle = '', _exl_mod = '') {
        let formData = [
            { name: 'type', value: 'BookingInjection' },
            { name: 'data', value: JSON.stringify(favourites) },
            { name: 'exl_dn', value: _distributor || distributor },
            { name: 'exl_bs', value: _brandingStyle || brandingStyle },
            { name: 'exl_lng', value: getLanguage() + '-JP' },
            { name: 'exl_cur', value: 'JPY' },
            {
                name: 'options',
                value: JSON.stringify({ OpenInNewWindow: true }),
            },
        ];
        formData = [...formData, ...extraExls];
        postFormData(endpoints.injection, formData);
    };
    const postFormData = function (url, formData) {
        const form = document.createElement('form');
        form.action = url;
        form.method = 'POST';
        formData.forEach(function (item) {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = item.name;
            input.value = item.value;
            form.appendChild(input);
        });
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    };
    return {
        search,
        getBooking,
        redirectToCABS,
        setDistributor,
        setBrandingStyle,
        setExtraExlData,
    };
}
export default V3Factory;
